import { View, Text, hexColor } from "@lightningtv/solid";
import { For, Show } from "solid-js";
import theme from "theme";

const blockWidth = 900;
const descriptionWidth = 700;

const ContentBlockStyle = {
  display: "flex",
  flexDirection: "column",
  flexBoundary: "fixed",
  width: blockWidth,
  height: 220,
  gap: 16,
};

const HeadlineStyles = {
  ...theme.typography.display2,
  fontFamily: "Roboto",
  fontWeight: 400,
  maxLines: 2,
  width: descriptionWidth * 2,
  contain: "width",
  top: 20,
};
const Headline = props => <Text {...props} style={HeadlineStyles}></Text>;

const DescriptionStyles = {
  ...theme.typography.body1,
  fontFamily: "Roboto",
  fontWeight: 400,
  lineHeight: 32,
  marginLeft: 40,
  width: descriptionWidth,
  maxLines: 5,
  contain: "width",
  color: "#b5b1b1",
};

const BadgeStyle = {
  fontSize: 16,
  lineHeight: 20,
  marginLeft: 13,
  marginRight: 13,
};

const Description = props => (
  <Text {...props} style={DescriptionStyles} >
    {props.children}
  </Text>
);

export const Badge = props => {
  return (
    <View
      {...props}
      style={{
        color: "0x00000099",
        borderRadius: 8,
        border: { width: 2, color: "0xffffffff" },
        display: "flex",
        height: 36,
      }}
    >
      <Text lineHeight={36} style={BadgeStyle}>
        {props.children}
      </Text>
    </View>
  );
};

const MetaTextStyle = {
  ...theme.typography.body2,
  fontFamily: "Roboto",
  fontWeight: 400,
};

const Metadata = props => (
  <View
    style={{
      display: "flex",
      flexDirection: "row",
      gap: 18,
      width: blockWidth,
      height: 48,
    }}
  >
    <View y={-4} src="./assets/stars.png" width={188} height={31}></View>
    <View y={-4} flexItem={false} clipping width={(188 * props.voteAverage) / 10} height={31}>
      <View src="./assets/stars-full.png" width={188} height={31}></View>
    </View>
    {/* @ts-ignore */}
    <Text style={MetaTextStyle}>{props.voteCount} reviews</Text>
    {/* @ts-ignore */}
    <Text style={MetaTextStyle}>{props.metaText}</Text>
    <For each={props.badges}>{item => <Badge y={-5}>{item}</Badge>}</For>
  </View>
);

const CoverImage = props => {
  return <View src={props.children} x={100} style={{ width: 400, height: 600, borderRadius: 10 }} />;
};

const ContentBlockSeries = props => {
  return (
    <View id="contentBlock" {...props}>
      <Headline>{props.content.title}</Headline>
      <View y={60} height={15}>
        <Text color={"#b5b1b1"} fontSize={32}>{props.content.genre}</Text>
      </View>

      {props.content.rating && (
        <View y={100} direction="row">
          {Array.from({ length: 5 }).map((_, index) => {
            const rawRating = props.content.rating;
            const rating = rawRating() !== undefined && rawRating() !== null && !isNaN(Number(rawRating()))
              ? parseFloat(rawRating().toString()) / 2 // Convert from 10 to 5 scale
              : 0;

            const fullStars = Math.floor(rating);
            const hasHalfStar = rating % 1 >= 0.5;

            const starSrc =
              index < fullStars
                ? 'https://i.ibb.co/4gK6MnK/star-1.png' // Full star
                : index === fullStars && hasHalfStar
                  ? 'https://i.ibb.co/9V7LVwc/rating.png' // Half star
                  : 'https://i.ibb.co/1KBsPWh/star-2.png'; // Empty star

            return (
              <View
                key={index}
                x={index * 35}
                width={30}
                height={30}
                src={starSrc}
              />
            );
          })}
        </View>
      )}

      <Description y={150}>{props.content.description}</Description>

    </View>
  );
};

export default ContentBlockSeries;
